module.exports = __webpack_public_path__ + "img/Brett.780e957d.png";